<div class="long-title">
    <h4 class="content-block ap-green">Add/Edit Equipment and Technology for Facility {{productionFacilityId}}</h4>
</div>

<div id="form-container">
    <form (submit)="handleSubmit($event)">
        <div style="margin-top: 15px;" class="card">
            <div class="card-body">
                <div class="table-responsive">
                    <table class="col-md-12">
                        <tr class="maxheight">
                            <td style="width: 25%;">
                                <div>
                                    <div>
                                        <span class="bold">Equipment Type</span><span class="red">*</span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <div class="dx-field">
                                        <dx-select-box class="controlwidth" name="equipmentType" id="equipmentType"
                                            [items]="activeEquipmentTypes" [searchEnabled]="true"
                                            displayExpr="providerName" valueExpr="id"
                                            [(value)]="equipmentItem.equipmentTypeId">
                                            <dx-validator>
                                                <dxi-validation-rule type="required"
                                                    message="Equipment Type is required">
                                                </dxi-validation-rule>
                                            </dx-validator>
                                        </dx-select-box>
                                    </div>
                                </div>
                            </td>
                            <td style="width: 20%;">
                                <div>
                                    <dx-button text="Add/Edit Type" class="ap-blue-btn btnwidth" 
                                        [useSubmitBehavior]="false" (onClick)="openEquipmentType()">
                                    </dx-button>
                                </div>
                            </td>
                        </tr>
                        <tr style="height: auto;">
                            <td>
                                <div class="flexdir">
                                    <div>
                                        <span class="bold">Equipment Customer</span><span class="red">*</span>
                                    </div>
                                    <div class="row">
                                        <label style="width:29%;">Various:</label>
                                        <div class="col-1" style="margin-left: -20px;">
                                            <dx-switch [(value)]="equipmentCustomerVarious"
                                                (onValueChanged)="handleVariousSwitchChange($event)">
                                            </dx-switch>
                                        </div>
                                        <label style="width:38%; margin-left: 10px;">Unspecified:</label>
                                        <div class="col-1" style="margin-left: -20px;">
                                            <dx-switch [(value)]="equipmentCustomerUnspecified"
                                                (onValueChanged)="handleUnspecifiedSwitchChange($event)"></dx-switch>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <div class="dx-field">
                                        <dx-text-box class="controlwidth" [(value)]="equipmentItem.customerSiteDesc"
                                            readOnly="true">
                                            <dx-validator>
                                                <dxi-validation-rule type="required"
                                                    message="Equipment Customer is required">
                                                </dxi-validation-rule>
                                            </dx-validator>
                                        </dx-text-box>
                                    </div>
                                </div>
                            </td>
                            <td style="width: 20%;">
                                <div>
                                    <dx-button text="Search Customers" class="ap-blue-btn btnwidth" [useSubmitBehavior]="false"
                                        (onClick)="openPopup()">
                                    </dx-button>
                                </div>
                            </td>
                        </tr>
                        <tr class="maxheight">
                            <td>
                                <div>
                                    <div>
                                        <span class="bold">Equipment Provider</span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <div class="dx-field">
                                        <dx-select-box class="controlwidth" name="equipmentProviderId"
                                            id="equipmentProviderId" [searchEnabled]="true"
                                            [items]="activeEquipmentProvidersDataSource" displayExpr="providerName"
                                            valueExpr="id" [(value)]="equipmentItem.equipmentProviderId">
                                        </dx-select-box>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <dx-button text="Add/Edit Provider" class="ap-blue-btn btnwidth"  [useSubmitBehavior]="false"
                                        (onClick)="openEquipmentProvider()">
                                    </dx-button>
                                </div>
                            </td>
                        </tr>
                        <tr class="maxheight">
                            <td style="width: 25%;">
                                <div>
                                    <div>
                                        <span class="bold">Engineering Provider</span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <div class="dx-field">
                                        <dx-select-box class="controlwidth" name="engineeringProviderId"
                                            id="engineeringProviderId" [searchEnabled]="true"
                                            [items]="activeEngineeringProvidersDataSource" displayExpr="providerName"
                                            valueExpr="id" [(value)]="equipmentItem.engineeringProviderId">
                                        </dx-select-box>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <dx-button text="Add/Edit Provider" class="ap-blue-btn btnwidth"  [useSubmitBehavior]="false"
                                        (onClick)="openEngineeringProvider()">
                                    </dx-button>
                                </div>
                            </td>
                        </tr>
                        <tr class="maxheight">
                            <td>
                                <div>
                                    <div>
                                        <span class="bold">Award Date</span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <div class="dx-field">
                                        <dx-select-box class="controlwidth" [dataSource]="awardYears"
                                            placeholder="Choose" [showClearButton]="true" displayExpr='Year' valueExpr='Year'
                                            [searchEnabled]="true" [(value)]="equipmentItem.awardYear">
                                        </dx-select-box>
                                    </div>
                                </div>
                            </td>
                            <td></td>
                        </tr>
                        <tr style="height: auto;">
                            <td>
                                <div class="flexdir">
                                    <div>
                                        <span class="bold">Equipment Model</span>
                                    </div>
                                    <div>
                                        <label>(Please include model if
                                            available)</label>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <div class="dx-field">
                                        <dx-text-box class="controlwidth"
                                            [(value)]="equipmentItem.equipmentDescription"></dx-text-box>
                                    </div>
                                </div>
                            </td>
                            <td>
                            </td>
                        </tr>
                        <tr class="maxheight">
                            <td>
                                <div>
                                    <div>
                                        <span class="bold">Contact Date</span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <div class="dx-field">
                                        <dx-date-box class="controlwidth" id="announcementDate"
                                            [(value)]="equipmentItem.lastContactedDate">
                                        </dx-date-box>
                                    </div>
                                </div>
                            </td>
                            <td></td>
                        </tr>
                        <tr class="maxheight">
                            <td>
                                <div>
                                    <div>
                                        <span class="bold">Technology Provider</span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <div class="dx-field">
                                        <dx-select-box class="controlwidth" name="equipmentProviderId"
                                            id="equipmentProviderId" [searchEnabled]="true"
                                            [items]="activeEquipmentProvidersDataSource" displayExpr="providerName"
                                            valueExpr="id" [(value)]="equipmentItem.equipmentProviderId">
                                        </dx-select-box>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <dx-button text="Add/Edit Provider" class="ap-blue-btn btnwidth" [useSubmitBehavior]="false"
                                        (onClick)="openTechProvider()">
                                    </dx-button>
                                </div>
                            </td>
                        </tr>
                        <tr class="maxheight">
                            <td>
                                <div>
                                    <div>
                                        <span class="bold">Industrial Gas Provider</span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <div class="dx-field">
                                        <dx-select-box class="controlwidth" name="industrialGasProviderId"
                                            id="industrialGasProviderId" [searchEnabled]="true"
                                            [items]="activeIndustrialGasDataSource" displayExpr="providerName"
                                            valueExpr="id" [(value)]="equipmentItem.industrialGasProviderId">
                                        </dx-select-box>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <dx-button text="Add/Edit Provider" class="ap-blue-btn btnwidth" [useSubmitBehavior]="false"
                                        (onClick)="openIndustrialGasProvider()">
                                    </dx-button>
                                </div>
                            </td>
                        </tr>
                        <tr class="maxheight">
                            <td>
                                <div>
                                    <div>
                                        <span class="bold">Award Status</span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <div class="dx-field">
                                        <dx-select-box class="controlwidth" [dataSource]="awardStatusList"
                                            placeholder="Choose" [showClearButton]="true" displayExpr="" valueExpr=""
                                            [searchEnabled]="true" [(value)]="equipmentItem.awardStatus">
                                        </dx-select-box>
                                    </div>
                                </div>
                            </td>
                            <td></td>
                        </tr>
                        <tr class="maxheight">
                            <td colspan="2">
                                <div>
                                    <div class="leftfloat">
                                        <dx-button text="Save" class="ap-green-btn mr-1 mt-1 ml-2 px-5" [useSubmitBehavior]="true"></dx-button>
                                    </div>
                                    <div class="leftfloat">
                                        <dx-button text="Cancel" class="ap-discard-button mr-1 mt-1 ml-2 px-5" (onClick)="onCancelClick($event)">
                                        </dx-button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </form>
</div>

<customer-site [buttonTrigger]="popupVisible" (setPopupVisibility)="setPopupVisibility($event)"
    (setSiteId)="setSiteId($event)" (setCustomer)="setCustomer($event)"></customer-site>

<dx-popup [width]="600" [height]="350" [showTitle]="false" title="Equipment and Technology" [dragEnabled]="false"
    [closeOnOutsideClick]="false" [(visible)]="equipmentPopupVisible" [showCloseButton]="true"
    (onContentReady)="onContentReady($event)">
    <div *dxTemplate="let data of 'content'">
        <h5 class="ap-green">Edit/Add New {{popupHeaderTitle}}</h5>
        <div id="form-container">
            <dx-form id="form" [colCount]="6" [formData]="frmCustomerSite" [showColonAfterLabel]="true">
                <dxi-item [colSpan]="4">
                    <label class="label-text">{{popupDropDownLabel}}</label>
                    <dx-select-box [dataSource]="equipmentDropDownList" placeholder="Choose" [showClearButton]="true"
                        displayExpr="providerName" valueExpr="id" [searchEnabled]="true"
                        (onValueChanged)="onEquipmentDropDownValueChanged($event)" [(value)]="equipmentDropDownValue">
                    </dx-select-box>
                </dxi-item>
                <dxi-item itemType="empty" [colSpan]="2"></dxi-item>
                <dxi-item [colSpan]="4">
                    <label class="label-text">{{popupHeaderTitle}} Name:</label>
                    <dx-text-box [(value)]="equipmentName" [showClearButton]="true" valueChangeEvent="keyup">
                    </dx-text-box>
                </dxi-item>
                <dxi-item itemType="empty" [colSpan]="2"></dxi-item>
                <dxi-item [colSpan]="4">
                    <div class="dx-field">
                        <dx-check-box [(value)]="activeFlag"></dx-check-box>
                        <div class="dx-field-label">&nbsp;Active Flag (Active if checked)</div>
                    </div>
                </dxi-item>
            </dx-form>
        </div>
        <div>
            <dx-button text="Save Close" type="success" (onClick)="savePopupInfo()"></dx-button>&nbsp;
            <dx-button text="Cancel" type="danger" (onClick)="onCancelPopupClick()"></dx-button>
        </div>
    </div>
</dx-popup>
<dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
    [shading]="true" [closeOnOutsideClick]="false">
</dx-load-panel>